var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Title", type: "text", readonly: "" },
                        model: {
                          value: _vm.client.Title,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "Title", $$v)
                          },
                          expression: "client.Title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "First name",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.FirstName,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "FirstName", $$v)
                          },
                          expression: "client.FirstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Last name",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.LastName,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "LastName", $$v)
                          },
                          expression: "client.LastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Email", type: "text", readonly: "" },
                        model: {
                          value: _vm.client.Email1,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "Email1", $$v)
                          },
                          expression: "client.Email1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Contact number",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.CellNumber1,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "CellNumber1", $$v)
                          },
                          expression: "client.CellNumber1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "ID Number",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.client.IdentityNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "IdentityNumber", $$v)
                          },
                          expression: "client.IdentityNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.client.DateOfBirth
                            ? _vm.client.DateOfBirth.substring(0, 10)
                            : "",
                          label: "Birth date",
                          type: "text",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Gender", type: "text", readonly: "" },
                        model: {
                          value: _vm.client.Gender,
                          callback: function($$v) {
                            _vm.$set(_vm.client, "Gender", $$v)
                          },
                          expression: "client.Gender"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }